import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { images, recentBuyers } from '../data/offer';
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * recentBuyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      const buyer = recentBuyers[index % recentBuyers.length];
      index += 1;
      setNotice({
        ...buyer,
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => setNotice(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 flex justify-start sm:inset-x-auto sm:bottom-28 sm:left-6" aria-live="polite" data-id="element-45" data-mp="116w8clejd5db">
      <AnimatePresence data-id="element-46" data-mp="1fuhcmin5damt">
        {notice && !dismissed && <motion.div key={notice.name + notice.minutes} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(10,27,51,0.22)]" data-id="element-47" data-mp="1aw60205gwm0w">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-brand-50 object-contain" data-id="element-48" data-mp="28jya3upmjhpw" />
            <div className="min-w-0" data-id="element-49" data-mp="23m6asfmngtbo">
              <p className="text-sm font-bold leading-tight text-navy" data-id="element-50" data-mp="23l3ettah00ow">
                {notice.name} <span className="font-medium text-ink-muted" data-id="element-51" data-mp="2ao1lith8thnn">from</span> {notice.country}
              </p>
              <p className="mt-0.5 text-[13px] leading-snug text-ink-muted" data-id="element-52" data-mp="2fltfru5d1fv0">just purchased the Clear Aligner Clinical Blueprint™</p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-success" data-id="element-53" data-mp="2pltypezbhtyo">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-54" data-mp="1ry3jau04mirx" />
                {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink-soft hover:bg-navy/5 hover:text-navy" aria-label="Dismiss notification" data-id="element-55" data-mp="1wxofwxrtqf1h">
              <XIcon className="h-4 w-4" data-id="element-56" data-mp="198dnq4ojhsyy" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}